import { environments } from 'environments/environments';
import React from 'react';
import { Route, Switch } from 'react-router';
import BandMembersList from './BandMembersList/BandMembersList';
import SingleBandMember from './SingleBandMember/SingleBandMember';
import SingleBandMembersEpoch from './SingleBandMembersEpoch/SingleBandMembersEpoch';

export default class BandSection extends React.Component {
  componentDidMount(): void {
    document.title = environments.pageTitle +  ' - Kapela';
  }

  render() {
    return (
      <div>
        <Switch>
          <Route path="/kapela" exact component={BandMembersList} />
          <Route path="/kapela/rok-:epoch" exact component={SingleBandMembersEpoch} />
          <Route path="/kapela/:member" exact component={SingleBandMember} />
        </Switch>
      </div>
    );
  }
}